import React from 'react';

import StrokeIcon, { StrokeIconProps } from './StrokeIcon';

export default function LineArrowUpIcon(props: StrokeIconProps): JSX.Element {
  return (
    <StrokeIcon {...props}>
      <path d="m5 12 7-7 7 7" />
      <path d="M12 19V5" />
    </StrokeIcon>
  );
}
